import store from '../store'
import vue_cookies from 'vue-cookies'

function buildDefaultParams () {
  let now = new Date()
  return {
    white_label_marca: store.state.flavor,
    modulo: store.state.filial,
    date_time: now.toLocaleString(),
    parceiro_usuario: store.state.id_usuario,
    parceiro_nome: store.state.nome,
    parceiro_email: store.state.dados_usuario_logado.email_pessoa,
    ambiente: store.state.ambiente,
    pv_parceiro: store.state.cd_ponto_venda,
    source_login: store.state.origem_acesso
  }
}

export function sendAnalyticsEvent (gtag, name, params = {}) {
  if (params !== null && vue_cookies.isKey('cookie_configuration')) {
    const cookie_config = vue_cookies.get('cookie_configuration')
    if (cookie_config.navigation_cookies_permission) {
      try {
        gtag.event(name, {
          ...buildDefaultParams(),
          ...params
        })
      } catch (err) {
        console.error('Erro ao Enviar os Analytics')
      }
    }
  }
}
